import IconButton from "@mui/material/Button";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {Button, DialogContent, FormControlLabel, FormGroup, TextField} from "@mui/material";
import * as React from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import {useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from '@mui/material/Checkbox';
import InputLabel from "@mui/material/InputLabel";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {FxmsData} from "../../../datas/FxData";

export const TextBox_CemsDash001DataMart = (props) => {
    const [open, setOpen] = useState(false)
    const [bgColor, setBgColor] = useState('#030000')
    const [alpha, setAlpha] = useState(99)
    const [value, setValue] = useState(0);
    const [api, setApi] = useState('')
    const [iconList, setIconList] = useState([
        'CEMS.MainDashboardElectricIcon.png', 'CEMS.MainDashboardFacilityIcon.png',
        'CEMS.MainDashboardGasIcon.png', 'CEMS.MainDashboardHeatIcon.png',
        'CEMS.MainDashboardMotorIcon.png',
        'air_icon.png', 'battery_yellow.png', 'carBattery_blue.png',
        'cemslogo.png','icon_energy_1.png','icon_energy_2.png',
        'logo192.png','logo512.png','water_default.png','water_icon.png',
        'waterTank_default.png'
    ])
    const handleCloseAndSave = () => {
        setOpen(false)
        props.handleCloseAndSave()
    }

    const handleColor = (e) => {
        let value = e.target.value
        setBgColor(value)
        // props.bgColor(value+alpha)
        props.options.setDesignOptions({...props.options.designOptions,bgColor:value+alpha})

    }
    const handleAlpha = (e) => {
        let value = e.target.value.toString(16).padStart(2, "0")
        setAlpha(value)
        // props.bgColor(bgColor+value)
        props.options.setDesignOptions({...props.options.designOptions,bgColor:bgColor+value})

    }
    const handleColors = (index,e) => {
        let base = props.options.designOptions.colors
        base[index] = e.target.value
        props.options.setDesignOptions({...props.options.designOptions,colors:base})
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <IconButton size={'small'} sx={{minWidth:0, right:'35px',position:'absolute',zIndex:999}} onClick={()=>setOpen(true)}>
                <SettingsIcon/>
            </IconButton>
            <Dialog onClose={handleCloseAndSave} open={open}>
                <DialogTitle>제목 및 데이터 설정</DialogTitle>
                <DialogContent>
                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="데이터 API" />
                        <Tab label="디자인 설정" />
                    </Tabs>
                    <CustomTabPanel value={value} index={0}>
                        <div>
                            <div>
                                API
                                <Button sx={{ml:10}} variant={"contained"} onClick={()=>{props.api(api)}}>실행</Button>
                            </div>
                            <TextField sx={{width:'600px',input:{color:'white'}, margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}}
                               placeholder={"API"} value={api}
                               onChange={(e)=>setApi(e.target.value)} />
                        </div>
                        <div>
                            <Button sx={{m:1}} variant={"contained"} onClick={()=>{
                                setApi('h2/component/comp-selected-chart-values?endDate=20230706&moNo=10002&psId=UNDEF&psKindName=15M&startDate=20230706')
                            }}>h2 trend data sample</Button>
                        </div>

                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <div style={{fontSize:'medium'}}>
                            제목
                            <TextField sx={{input:{color:'white'}, margin:'15px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                '.MuiSvgIcon-root ': {fill: "white !important",}}} placeholder={"set title"} onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,title:e.target.value})}} value={props.options.designOptions.title} />
                            <div>
                                <div>배경색 및 투명 설정</div>
                                <input id="color_picker" onInput={handleColor} type="color" value={bgColor} />
                                <input id="color_picker_alpha" onInput={handleAlpha} type="range" min="0" max="99" step="1" value={alpha}/>
                                <TextField sx={{input:{color:'white'}, margin:'15px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}}} placeholder={"배경색 직접입력"} onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,bgColor:e.target.value})}} value={props.options.designOptions.bgColor}/>
                            </div>
                            <div>
                                <div>제목 크기, 색 설정</div>
                                <FormControl sx={{m:'5px',minWidth:'150px'}}>
                                    <InputLabel>제목정렬</InputLabel>
                                    <Select style={{color:'white'}}
                                            value={props.options.designOptions.titleAlign}
                                            label="제목정렬"
                                            onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,titleAlign:e.target.value})}}
                                    >
                                        <MenuItem style={{color:'white'}} value={"left"}>left</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"center"}>center</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"right"}>right</MenuItem>
                                    </Select>
                                </FormControl>
                                <input id="color_picker" onInput={(e)=>{props.options.setDesignOptions({...props.options.designOptions,titleColor:e.target.value})}} type="color" value={props.options.designOptions.titleColor} />
                                <TextField sx={{input:{color:"white",fontSize:"10px",padding:'none'}, margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}}}
                                           placeholder={"제목 크기"}
                                           type="number" value={props.options.designOptions.fontSize}
                                           onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,fontSize:e.target.value})}} />
                            </div>
                            <div>
                                <div>Content1 설정 - 정렬, 색상, 크기, 단위</div>
                                <FormControl sx={{m:'5px',minWidth:'150px'}}>
                                    <InputLabel>Content1 ICON 선택</InputLabel>
                                    <Select style={{color:'white'}}
                                            value={props.options.designOptions.icon1}
                                            label="Content1 ICON 선택"
                                            onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,icon1:e.target.value})}}
                                    >
                                        {iconList.map(x=>{
                                            return <MenuItem style={{color:'white'}} value={x}><img width='30px' src={x}/></MenuItem>
                                        })}

                                    </Select>
                                </FormControl>
                                <FormControl sx={{m:'5px',minWidth:'150px'}}>
                                    <InputLabel>Content 정렬</InputLabel>
                                    <Select style={{color:'white'}}
                                            value={props.options.designOptions.content1Align}
                                            label="Content1 정렬"
                                            onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,content1Align:e.target.value})}}
                                    >
                                        <MenuItem style={{color:'white'}} value={"left"}>left</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"center"}>center</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"right"}>right</MenuItem>
                                    </Select>
                                </FormControl>
                                <input id="color_picker" onInput={(e)=>{props.options.setDesignOptions({...props.options.designOptions,content1Color:e.target.value})}} type="color" value={props.options.designOptions.content1Color} />
                                <TextField sx={{input:{color:"white",fontSize:"10px",padding:'none'}, margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}}}
                                           placeholder={"content1 색상"}
                                           value={props.options.designOptions.content1Color}
                                           onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,content1Color:e.target.value})}} />
                                <TextField sx={{input:{color:"white",fontSize:"10px",padding:'none'}, margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}}}
                                           placeholder={"content1 크기"}
                                           type="number" value={props.options.designOptions.content1Size}
                                           onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,content1Size:e.target.value})}} />
                                <div>Content2 설정 - 정렬, 색상, 크기, 단위</div>
                                <FormControl sx={{m:'5px',minWidth:'150px'}}>
                                    <FormControl sx={{m:'5px',minWidth:'150px'}}>
                                        <InputLabel>Content2 ICON 선택</InputLabel>
                                        <Select style={{color:'white'}}
                                                value={props.options.designOptions.icon2}
                                                label="Content2 ICON 선택"
                                                onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,icon2:e.target.value})}}
                                        >
                                            {iconList.map(x=>{
                                                return <MenuItem style={{color:'white'}} value={x}><img width='30px' src={x}/></MenuItem>
                                            })}

                                        </Select>
                                    </FormControl>
                                    <InputLabel>Content 정렬</InputLabel>
                                    <Select style={{color:'white'}}
                                            value={props.options.designOptions.content2Align}
                                            label="Content2 정렬"
                                            onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,content2Align:e.target.value})}}
                                    >
                                        <MenuItem style={{color:'white'}} value={"left"}>left</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"center"}>center</MenuItem>
                                        <MenuItem style={{color:'white'}} value={"right"}>right</MenuItem>
                                    </Select>
                                </FormControl>
                                <input id="color_picker" onInput={(e)=>{props.options.setDesignOptions({...props.options.designOptions,content2Color:e.target.value})}} type="color" value={props.options.designOptions.content2Color} />
                                <TextField sx={{input:{color:"white",fontSize:"10px",padding:'none'}, margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}}}
                                           placeholder={"색상"}
                                           value={props.options.designOptions.content2Color}
                                           onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,content2Color:e.target.value})}} />
                                <TextField sx={{input:{color:"white",fontSize:"10px",padding:'none'}, margin:'5px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}}}
                                           placeholder={"소제목 크기"}
                                           type="number" value={props.options.designOptions.content2Size}
                                           onChange={(e)=>{props.options.setDesignOptions({...props.options.designOptions,content2Size:e.target.value})}} />

                            </div>

                        </div>
                    </CustomTabPanel>

                </DialogContent>
            </Dialog>
        </div>

    )
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}